<template lang="pug">
  validation-observer(ref="obs" v-slot="{ invalid }")
    v-card(flat)
      v-card-title(
        class="d-block secondary--text font-weight-bold text-center"
      ) Вход в систему
      v-card-text.pb-0
        .text-center.text-body-2
          span Еще нет аккаунта?
          router-link.ml-1.text-decoration-none(:to="{ name: 'SignUp' }") Зарегистрироваться

        .text-caption.d-flex.mt-12.ml-2.align-center.mb-4
          v-icon.mr-2 mdi-information-outline
          span Можно использовать логин и пароль
          a.ml-1.text-decoration-none(href="pfdo.ru") ПФДО
        v-form(ref="form")
          validation-provider(
            rules="required"
            name="Имя пользователя"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="username"
              ref="username"
              name="username"
              label="Имя пользователя"
              @keyup.enter="login"
              :error-messages="errors"
              filled
              rounded
            )
          validation-provider(
            rules="required"
            name="Пароль"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="password"
              name="password"
              ref="password"
              @keyup.enter="login"
              label="Пароль"
              :error-messages="errors"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              filled
              rounded
            )
          .d-flex
            v-btn.px-5.ml-auto(
              text
              rounded color="primary" small
              @click="openResetPasswordDialog"
            ) Восстановить пароль
          //- v-switch(v-model="localLogin" label="Войти локально" hide-details)
      v-card-actions.flex-column.mt-8
        v-btn(
          color="success"
          class="text-uppercase"
          @click="login"
          :loading="loadingBtn"
          depressed block large
          rounded
        ) Войти
        v-btn.mt-4(
          outlined
          rounded
          block large
          color="primary"
          @click="getTelegramAuth"
        )
          v-icon.ml-2() $telegram
          | Войти через телеграм
</template>

<script>
import { mapActions } from 'vuex';
import ResetPasswordModal from './ResetPasswordModal.vue';

export default {
  name: 'SignInForm',
  props: {
    redirect: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    username: '',
    password: '',
    showPassword: false,
    loadingBtn: false,
    // localLogin: false,
  }),
  methods: {
    async getTelegramAuth() {
      const { data } = await this.$api.auth.getTelegramAuth();
      const { uri } = data.data;
      window.location.href = uri;
    },
    openResetPasswordDialog() {
      this.$modals.show('generic-controller', {
        title: 'Восстановление пароля',
        component: ResetPasswordModal,
        dialogProps: {
          'max-width': 600,
        },
      });
    },
    ...mapActions({ AUTHENTICATE: 'auth/AUTHENTICATE' }),
    login() {
      this.loadingBtn = true;
      const loginData = {
        username: this.username,
        password: this.password,
        // isLocal: this.localLogin,
      };
      this.AUTHENTICATE(loginData)
        .then(() => {
          this.loadingBtn = false;

          if (this.redirect) {
            this.$router.push(this.redirect);
            return;
          }
          this.$router.push({ name: 'Desktop' });
        })
        .catch(() => {
          this.loadingBtn = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
